import classNames from "classnames";
import React from "react";
import { DoorIconProps } from "./DeKaap";

export const DeIjssel: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={28}
      height={60}
      viewBox="0 0 29 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-duration-150 gg-ease-in-out", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.0909 2H2.81818V8H15C17.7614 8 20 10.2386 20 13V16H26V17H20V58H26.0909V2ZM19 16V13C19 10.7909 17.2091 9 15 9H2.81818V58H8V21C8 18.2386 10.2386 16 13 16H19ZM9 58H19V17H13C10.7909 17 9 18.7909 9 21V58ZM0.818176 0V60H28.0909V0H0.818176Z"
        fill="currentColor"
      />
    </svg>
  );
};
